import { render } from "./PrintBankDetails.vue?vue&type=template&id=48b57907"
import script from "./PrintBankDetails.vue?vue&type=script&lang=js"
export * from "./PrintBankDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__